import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import FluidBackgroundImg from 'Components/Utility/FluidBackgroundImg';

import 'Components/Wishlist/WishlistSyncBanner.scss';

const WishlistSyncBanner = () => (
  <Link to={'/account/linked-accounts'} className="WishlistSyncBanner">
    <FluidBackgroundImg
      className="WishlistSyncBanner__backgroundWrapper"
      folder="assets/wishlist"
      src="steam-background.png"
      heights={{ xs: 264, sm: 264, md: 264, lg: 264, xl: 264, xxl: 264 }}
      tagName="header"
      fit="crop"
    >
      <div className="WishlistSyncBanner__content">
        <div className="WishlistSyncBanner__titleContainer">
          <div className="WishlistSyncBanner__title">
            <FormattedMessage id="steam-sync-banner.syncyoursteamwishlist" defaultMessage="Sync your Steam Wishlist" />
          </div>
          <div className="WishlistSyncBanner__subTitle">
            <FormattedMessage id="steam-sync-banner.desc" defaultMessage="Connect your steam account and you can import your games from your Steam Wishlist" />
          </div>
        </div>

        <div className="WishlistSyncBanner__button">
          <FormattedMessage id="steam-sync-banner.sync" defaultMessage="Sync" />
          <img
            className="WishlistSyncBanner__buttonImage"
            src="https://cdn.fanatical.com/production/assets/wishlist/steam-drm-blue.svg"
            alt="Steam logo"
            width="100%"
            height="100%"
          />
          <FormattedMessage id="steam-sync-banner.wishlist" defaultMessage="Wishlist" />
        </div>
      </div>
    </FluidBackgroundImg>
  </Link>
);

export default WishlistSyncBanner;
